<template>
    <b-button
        v-bind="$attrs"
        :variant="variant"
        :disabled="isDisabled"
        :size="size"
        @click="click"
    >
        <b-spinner v-if="loading" small label="Spinning" class="mr-2" />
        <span v-if="loading">Loading...</span>
        <span v-else><slot /></span>
    </b-button>
</template>

<script>
// depricated
import { BButton } from "bootstrap-vue";

export default {
    inheritAttrs: false,

    name: "LoadingBtn",

    components: {
        "b-button": BButton,
    },

    props: {
        // loading prop to change the status of this component.
        loading: {
            type: Boolean,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        variant: {
            type: String,
            default: "primary",
        },
        size: {
            type: String,
            default: "",
        },
    },

    computed: {
        isDisabled() {
            return this.disabled || this.loading;
        },
    },

    methods: {
        click(event) {
            this.$emit("click", event);
        },
    },
};
</script>
